import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import PhoneIcon from '@mui/icons-material/Phone';
import whatsappIcon from '../../assets/whatsapp-icon.svg';

const WHATSAPP_GREEN = '#25D366';
const WHATSAPP_GREEN_HOVER = '#1da851';

const styles = {
  card: {
    border: 1,
    borderColor: 'divider',
    borderRadius: '12px',
    p: 2.5,
    textAlign: 'left',
  },
  title: (theme) => ({
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(18),
    color: 'secondary.main',
    mb: 0.75,
  }),
  description: (theme) => ({
    fontSize: theme.typography.pxToRem(13),
    color: 'text.secondary',
    mb: 2,
    lineHeight: 1.5,
  }),
  buttons: { display: 'flex', gap: 1.5 },
  whatsappBtn: (theme) => ({
    flex: 1,
    bgcolor: WHATSAPP_GREEN,
    color: 'common.white',
    fontWeight: 'bold',
    borderRadius: '24px',
    py: 1.25,
    fontSize: theme.typography.pxToRem(14),
    '&:hover': { bgcolor: WHATSAPP_GREEN_HOVER },
  }),
  callBtn: (theme) => ({
    flex: 1,
    fontWeight: 'bold',
    borderRadius: '24px',
    py: 1.25,
    fontSize: theme.typography.pxToRem(14),
    borderColor: 'divider',
    color: 'secondary.main',
  }),
};

const HelpCard = ({
  title,
  description,
  whatsappLabel,
  callLabel,
  onWhatsapp,
  onCall,
  whatsappHref,
}) => (
  <Box sx={styles.card}>
    <Typography sx={styles.title}>{title}</Typography>
    <Typography sx={styles.description}>{description}</Typography>
    <Box sx={styles.buttons}>
      <Button
        sx={styles.whatsappBtn}
        href={whatsappHref}
        target='_blank'
        rel='noopener noreferrer'
        onClick={onWhatsapp}
        startIcon={
          <img src={whatsappIcon} alt='' style={{ width: 18, height: 18 }} />
        }
      >
        {whatsappLabel}
      </Button>
      <Button
        variant='outlined'
        sx={styles.callBtn}
        onClick={onCall}
        startIcon={<PhoneIcon sx={{ fontSize: 18 }} />}
      >
        {callLabel}
      </Button>
    </Box>
  </Box>
);

HelpCard.propTypes = {
  callLabel: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onCall: PropTypes.func,
  onWhatsapp: PropTypes.func,
  title: PropTypes.string.isRequired,
  whatsappHref: PropTypes.string,
  whatsappLabel: PropTypes.string.isRequired,
};

export default HelpCard;
